var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({ callback: _vm.visibilityChanged, throttle: 0, once: _vm.once }),expression:"{ callback: visibilityChanged, throttle: 0, once }"}]})}
var staticRenderFns = []

export { render, staticRenderFns }